import React, { type ComponentProps } from 'react';
import {
  Box,
  Button,
  ButtonIcon,
  Icon,
  Illustration,
  Typography,
} from '@saviynt/design-system';

import './ExternalBanner.css';

const AGENTIC_AI_SECURITY_URL =
  'https://saviynt.com/features/agentic-ai-security';
/** Inferred from Illustration; avoids importing IllustrationKind (not always re-exported by DS). */

type ExternalBannerIllustrationKind = NonNullable<
  ComponentProps<typeof Illustration>['kind']
>;

interface ExternalBannerProps {
  heading: string;
  subHeading: string;
  showButton: boolean;
  showClose: boolean;
  buttonText?: string;
  closeExtBanner?: () => void;
  illustration: ExternalBannerIllustrationKind;
}

function ExternalBanner({
  heading,
  subHeading,
  buttonText,
  showButton,
  showClose,
  closeExtBanner,
  illustration,
}: ExternalBannerProps) {
  return (
    <Box className='Ext-ExternalBanner'>
      <Box>
        <Typography
          kind='h2'
          color='--color-background-neutral-subtlest'
          className='Ext-ExternalBanner-heading'>
          {heading}
        </Typography>
        <Typography kind='body1' color='--color-background-neutral-subtlest'>
          {subHeading}
        </Typography>
        {showButton && (
          <div className='Ext-ExternalBanner-btnGroup'>
            <Button
              type='button'
              kind='filled'
              onClick={() => {
                window.open(
                  AGENTIC_AI_SECURITY_URL,
                  '_blank',
                  'noopener,noreferrer'
                );
              }}
              rightIcon={
                <Icon
                  kind='ArrowRight'
                  size='medium'
                  color='neutral-100'
                  data-testid='arrow-right-icon'
                />
              }>
              {buttonText}
            </Button>
            {/* Temporarily commenting out the code until the actual links are available. */}
            {/* <Typography
              kind='body2'
              color='--color-background-neutral-subtlest'>
              <a
                href='https://docs.saviyntcloud.com/'
                target='_blank'
                className='Ext-ExternalBanner-btnGroup-link'
                rel='noopener noreferrer'>
                Learn more about the value of user classification
              </a>
            </Typography> */}
          </div>
        )}
      </Box>
      <Box className='Ext-ExternalBanner-actions'>
        <div>
          <Illustration kind={illustration} />
        </div>
        {showClose && closeExtBanner && (
          <div>
            <ButtonIcon
              className='Ext-ExternalBanner-dismiss'
              size='large'
              kind='ghost'
              icon={<Icon kind='Close' />}
              onClick={() => {
                closeExtBanner();
              }}
              ariaLabel='Close Banner'
              dataTheme='dark'
            />
          </div>
        )}
      </Box>
    </Box>
  );
}

export default ExternalBanner;

ExternalBanner.defaultProps = {
  closeExtBanner: () => {},
  buttonText: 'Begin',
};
